export function useBackUrl(href) {
  const query = new URLSearchParams(location.search)

  if (!query.get('backUrl') && !['log-in', 'sign-up', 'forgot'].some(v => location.pathname.includes(v))) {
    query.set('backUrl', location.pathname)
  }

  return `${href}?${query.toString()}`
}

export function useRtl() {
  const { locale } = useI18n()

  const isRtl = computed(() => ['ar'].includes(locale.value))

  return { isRtl }
}
